import React, {Component} from 'react';
import * as Actions from '../../pages/actions/ActionCenter';

import { GlobalStates } from '../../pages/states/GlobalStates';

import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {Button, Badge, Container, Dropdown, Nav, Navbar} from 'react-bootstrap';

import SimpleBar from 'simplebar-react';

import Cookies from "js-cookie";

import * as util from '../../library/utilitys';

import {toggleCollapsedNav} from '../../redux/action/Theme';

class TopNav extends Component {

    constructor(props){
        super(props);

        const cookieValue = Cookies.get("userProfile");
        const decoded = cookieValue ? decodeURIComponent(cookieValue) : null;

        this.state = {
                ...GlobalStates,
                showDropdown: false,
                userProfile: decoded ? JSON.parse(decoded) : null,
        };
        this.updateState = this.setState.bind(this);
    }
     
    initialize = async () => {
        await this.loadMasterbase();
    }

    loadMasterbase = async () => {
        // console.log("topnav",this.state);
        let sets = [
            {key: 'permission_name', filter: [{field: "status", value: "0"}]},
        ]; 
        Actions.loadMasterbase(this.updateState, sets); 
    }
    
    toggleDropdown = () => { this.setState({showDropdown: !this.state.showDropdown});}

    componentDidMount = async () => {
        await this.initialize(); 
    }

    componentDidUpdate = async () => {}

    render = () => {
        
        const {navCollapsed, toggleCollapsedNav} = this.props;
        const { Masterbase, userProfile } = this.state;
        
        let masterSubtypes = Masterbase.permission_name;
        
        let subtypes = masterSubtypes?.find(option =>
                                                String(option.types) === String(userProfile?.types) &&
                                                String(option.id) === String(userProfile?.subtypes)
                                            ) ?? null;
        

        /**
        const pageVariants = {
            initial: { opacity: 0, y: 10},
            open: { opacity: 1, y: 0},
            close: { opacity: 0, y: 10}
        };
        */

        const { userProfile : up } = this.state;

        let initials = "";
        if (up && up.username) {
            const parts = up.username.trim().split(" ");
            if (parts.length === 1) {
                initials = parts[0].slice(0, 2).toUpperCase();
            } else {
                initials = (parts[0][0] + parts[1][0]).toUpperCase();
            }
        }

        return (
            <>
                <Navbar expand="xl" className="hk-navbar navbar-light fixed-top">
                    <Container fluid>
                        <div className="nav-start-wrap">
                            <Button variant="flush-dark" onClick={() => toggleCollapsedNav(!navCollapsed)} className="btn-icon btn-rounded navbar-toggle d-xl-none">
                                <span className="icon">
                                    <span className="feather-icon">
                                        <i className="fa-classic fa-solid fa-bars fa-fw"></i>
                                    </span>
                                </span>
                            </Button>
                        </div>
                        <div className="nav-end-wrap" >
                            <Nav className="navbar-nav flex-row">
                                <Nav.Item >
                                    {/* <Dropdown className="dropdown-notifications">
                                        <Dropdown.Toggle variant="flush-dark" className="btn-icon btn-rounded flush-soft-hover no-caret">
                                            <div className="avatar avatar-icon avatar-light avatar-xs avatar-rounded">
                                                <span className="initial-wrap">
                                                    <i className="fa-classic fa-light fa-bell fa-fw"></i>
                                                </span>
                                                <Badge bg="success" className="badge-sm position-bottom-end-overflow-1">5</Badge>
                                            </div>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu align="end" className="p-0">
                                            <Dropdown.Header className="px-4 fs-6">
                                                แจ้งเตือน
                                                <Button variant="fluash-dark" className="btn-icon btn-rounded falush-soft-hover">
                                                    <span className="icon">
                                                        <span className="feather-icon">
                                                            <i className="fa-classic fa-light fa-gear-complex fa-fw"></i>
                                                        </span>
                                                    </span>
                                                </Button>
                                            </Dropdown.Header>
                                            <SimpleBar className="dropdown-body p-2" autoHide={false} style={{ height: 'auto', maxHeight: '500px' }}>
                                                <Dropdown.Item>
                                                    <div className="media">
                                                        <div className="media-head">
                                                            <div className="avatar avatar-icon avatar-xs avatar-primary avatar-rounded">
                                                                <span className="initial-wrap">
                                                                    <i className="fa-classic fa-light fa-user fa-fw"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="media-body">
                                                            <div>
                                                                <div className="notifications-text">ร่างหลักสูตร EEC TYPE B</div>
                                                                <div className="notifications-info">
                                                                    <Badge bg="success">5 หลักสูตร</Badge>
                                                                    <div className="notifications-time">17 กุมภาพันธ์ 2568 14:05:23</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Dropdown.Item>
                                            </SimpleBar>
                                            <div className="dropdown-footer"><Link to="#"><u>การแจ้งเตือนทั้งหมด</u></Link></div>
                                        </Dropdown.Menu>
                                    </Dropdown> */}
                                </Nav.Item>
                                <Nav.Item>
                                    <Dropdown className="ps-2">
                                        <Dropdown.Toggle variant="flush-dark" className="btn-icon btn-rounded flush-soft-hover no-caret">
                                            <div className="avatar avatar-icon avatar-primary avatar-xs avatar-rounded">
                                                <span className="initial-wrap">
                                                      <i
                                                        className={
                                                            userProfile?.types === '0' ? 'fa-classic fa-light fa-user-alien fa-fw' :
                                                            userProfile?.types === '1' ? 'fa-classic fa-light fa-user-astronaut fa-fw' :
                                                            userProfile?.types === '2' ? 'fa-classic fa-light fa-user-graduate fa-fw' :
                                                            userProfile?.types === '3' ? 'fa-classic fa-light fa-user-tie-hair fa-fw' :
                                                            userProfile?.types === '4' ? 'fa-classic fa-light fa-people-pants-simple fa-fw' :
                                                            userProfile?.types === '5' ? 'fa-classic fa-light fa-users fa-fw' :
                                                            'fa-classic fa-light fa-ban fa-fw me-2'
                                                        }
                                                        ></i>
                                                </span>
                                            </div>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu align="end">
                                            <div className="p-2">
                                                <div className="media d-flex align-items-center w-100">
                                                    <div className="media-head me-2">
                                                        <div className="avatar avatar-sm avatar-primary avatar-rounded">
                                                            <span className="initial-wrap">{initials}</span>
                                                        </div>
                                                    </div>
                                                    <div className="media-body w-100">
                                                        {/* <Link to="#" className="d-block link-dark">{this.state.userProfile?.username} </Link> */}
                                                        <Link to="#" className="d-block link-dark">{userProfile?.username} </Link>
                                                        <div className="d-flex">
                                                            <div className="ms-auto text-end w-100">
                                                                {/* <Link to="#" className="title-xs m-0 fs-14 d-block">{this.state.userProfile?.position}</Link> */}
                                                                {/* <Link to="#" className="d-block link-dark">ผู้ดูแลระบบ </Link> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Dropdown.Divider as="div" />
                                            <Dropdown.Item>
                                                <span className="d-block link-dark">
                                                    {userProfile?.types === '0' ? 'SUPER ADMIN' :
                                                    userProfile?.types === '1' ? 'ADMIN SYSTEM' :
                                                    userProfile?.types === '2' ? 'USER EDU' :
                                                    userProfile?.types === '3' ? 'USER ENT' :
                                                    userProfile?.types === '4' ? 'EXTERNAL USER' :
                                                    userProfile?.types === '5' ? 'EEC บางรัก' :
                                                    'PROHIBIT USER'}
                                                    {subtypes?.name && (
                                                            <>
                                                            {" ( "}
                                                                {subtypes?.name}
                                                            {" ) "}
                                                            </>
                                                        )}
                                                </span>

                                                {userProfile?.types === '2' && (
                                                    <div className="mt-2">{userProfile?.academy_name}</div>
                                                )}

                                                {userProfile?.types === '3' && (
                                                    <div className="mt-2">{userProfile?.operator_name}</div>
                                                )}
                                            </Dropdown.Item>
                                            <Dropdown.Divider as="div" />
                                            <Dropdown.Item>
                                                <div className="p-2">
                                                    <div className="media">
                                                        <div className="media-body">
                                                            {/* <span className="d-block fs-8 link-secondary">{this.state.userProfile?.email}</span> */}
                                                            <span className="d-block link-dark">{userProfile?.fullname}</span>
                                                            <span className="d-block fs-8 link-secondary">{userProfile?.email}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Dropdown.Item>
                                            <Dropdown.Divider as="div" />   
                                            {/* <Dropdown.Divider as="div" />
                                                <Dropdown.Item as={Link} to="/pages/profile"><i className="fa-classic fa-light fa-user fa-fw"></i> โปรไฟล์</Dropdown.Item>
                                                <Dropdown.Item as={Link} to="/pages/lockScreen"><i className="fa-classic fa-light fa-lock fa-fw"></i> ล็อคหน้าจอ</Dropdown.Item>
                                                <Dropdown.Item as={Link} to="/pages/changePassword"><i className="fa-classic fa-light fa-key fa-fw"></i> เปลี่ยนรหัสผ่าน</Dropdown.Item>
                                            <Dropdown.Divider as="div" /> */}
                                            <Dropdown.Item as={Link} to="/logout"><i className="fa-classic fa-light fa-arrow-right-from-bracket fa-fw"></i> ออกจากระบบ</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Nav.Item>
                            </Nav>
                        </div>
                    </Container>
                </Navbar>
            </>
        )
    }
}

const mapStateToProps = ( {theme} ) => {
    const { navCollapsed } = theme;
    return { navCollapsed };
}
export default connect(mapStateToProps, { toggleCollapsedNav} )(TopNav);